module.exports = __webpack_public_path__ + "static/media/shape4.202be946.svg";